<template>
  <div
    class="content2_box"
    style="width: 340px; padding-bottom: 5px; float: left"
  >
    <div class="content2_title" style="position: relative">
      <router-link
        v-if="item.uid == 'A31010'"
        :to="{ path: '/list', query: { uid: item.uid, type: '0' } }"
        class="f21"
        >政府创新</router-link
      >
      <router-link
        v-else-if="item.uid == 'A31047'"
        :to="{ path: '/list', query: { uid: item.uid, type: '1' } }"
        class="f21"
        >{{ item.text }}</router-link
      >
      <router-link
        v-else
        :to="{ path: '/list', query: { uid: item.uid, type: '0' } }"
        class="f21"
        >{{ item.text }}</router-link
      >

      <template v-if="item.uid == 'A31001'">
        <a @click="clickKeyword($event, '17041')" class="f22" target="_blank"
          >会议</a
        >&nbsp;|&nbsp;<a
          @click="clickKeyword($event, '17041')"
          class="f22 f8"
          target="_blank"
          >讲话</a
        >
      </template>
      <template v-if="item.uid == 'A302'">
        <a @click="clickKeyword($event, '20718')" class="f22" target="_blank"
          >经济合作</a
        >&nbsp;|&nbsp;<a
          @click="clickKeyword($event, '20718')"
          class="f22 f8"
          target="_blank"
          >国际金融</a
        >
      </template>
      <template v-if="item.uid == 'A303'">
        <a @click="clickKeyword($event, '17036')" class="f22" target="_blank"
          >经济政策</a
        >&nbsp;|&nbsp;<a
          @click="clickKeyword($event, '17036')"
          class="f22 f8"
          target="_blank"
          >高质量发展</a
        >
      </template>
      <template v-if="item.uid == 'A304'">
        <a @click="clickKeyword($event, '17037')" class="f22" target="_blank"
          >城市群</a
        >&nbsp;|&nbsp;<a
          @click="clickKeyword($event, '17037')"
          class="f22 f8"
          target="_blank"
          >区域协调发展</a
        >
      </template>
      <template v-if="item.uid == 'A31010'">
        <a @click="clickKeyword($event, '17065')" class="f22" target="_blank"
          >数字政府</a
        >&nbsp;|&nbsp;<a
          @click="clickKeyword($event, '17065')"
          class="f22 f8"
          target="_blank"
          >公共服务</a
        >
      </template>
      <template v-if="item.uid == 'A31003'">
        <a @click="clickKeyword($event, '17051')" class="f22" target="_blank"
          >体制机制</a
        >&nbsp;|&nbsp;<a
          @click="clickKeyword($event, '17051')"
          class="f22 f8"
          target="_blank"
          >深化改革</a
        >
      </template>
      <template v-if="item.uid == 'A31033'">
        <a @click="clickKeyword($event, '24162')" class="f22" target="_blank"
          >科技创新</a
        >&nbsp;|&nbsp;<a
          @click="clickKeyword($event, '24162')"
          class="f22 f8"
          target="_blank"
          >发展战略</a
        >
      </template>
      <template v-if="item.uid == 'A31041'">
        <a @click="clickKeyword($event, '25005')" class="f22" target="_blank"
          >政府采购</a
        >&nbsp;|&nbsp;<a
          @click="clickKeyword($event, '25005')"
          class="f22 f8"
          target="_blank"
          >放管服</a
        >
      </template>
      <template v-if="item.uid == 'A31030'">
        <a @click="clickKeyword($event, '16969')" class="f22" target="_blank"
          >城市更新</a
        >&nbsp;|&nbsp;<a
          @click="clickKeyword($event, '16969')"
          class="f22 f8"
          target="_blank"
          >城乡一体化</a
        >
      </template>
      <template v-if="item.uid == 'A31047'">
        <a @click="clickKeyword($event, '50026')" class="f22" target="_blank"
          >营商环境</a
        >&nbsp;|&nbsp;<a
          @click="clickKeyword($event, '50026')"
          class="f22 f8"
          target="_blank"
          >文化旅游</a
        >
      </template>
      <template v-if="item.uid == 'A31006'">
        <a @click="clickKeyword($event, '20737')" class="f22" target="_blank"
          >老龄化</a
        >&nbsp;|&nbsp;<a
          @click="clickKeyword($event, '20737')"
          class="f22 f8"
          target="_blank"
        >
          就业</a
        >
      </template>
      <template v-if="item.uid == 'A31009'">
        <a @click="clickKeyword($event, '17058')" class="f22" target="_blank"
          >低碳</a
        >&nbsp;|&nbsp;<a
          @click="clickKeyword($event, '17058')"
          class="f22 f8"
          target="_blank"
        >
          生态</a
        >
      </template>
      <span style="float: right">
        <router-link
          v-if="item.uid == 'A31047'"
          :to="{ path: '/list', query: { uid: item.uid, type: '1' } }"
          class="f23"
        >
          更多+
        </router-link>
        <router-link
          v-else
          :to="{ path: '/list', query: { uid: item.uid, type: '0' } }"
          class="f23"
        >
          更多+
        </router-link>
      </span>
    </div>

    <div class="content2_pic" style="width: 340px; margin-top: 16px">
      <ul>
        <li>
          <template v-if="firstArticle.uid">
            <img
              :src="
                require('./images/default_pic_' + firstArticle.uid + '.jpg')
              "
              width="157"
              height="97"
              style="float: left"
            />
          </template>
          <div class="content2_smalltitle" style="float: right">
            <h4>
              <template v-if="firstArticle.code">
                <a
                  name="subject"
                  :href="
                    $ArticleUrl+'?chnid=' +
                    firstArticle.chnid +
                    '&leafid=' +
                    firstArticle.leafid +
                    '&docid=' +
                    firstArticle.code.substring(4, firstArticle.code.length) +
                    '&uid=' +
                    item.uid +
                    '&version=gov'
                  "
                  :title="firstArticle.title"
                  target="_blank"
                  style="color: black"
                  class="overflow-rule"
                  >{{ firstArticle.title }}</a
                >
              </template>
            </h4>
            <template v-if="firstArticle.code">
              <a
                :href="
                  $ArticleUrl+'?chnid=' +
                  firstArticle.chnid +
                  '&leafid=' +
                  firstArticle.leafid +
                  '&docid=' +
                  firstArticle.code.substring(4, firstArticle.code.length) +
                  '&uid=' +
                  item.uid +
                  '&version=gov'
                "
                target="_blank"
                class="f7 f6"
                ><span name="summary" class="overflow-rule">{{
                  firstArticle.summary
                }}</span></a
              >
            </template>
          </div>
        </li>
      </ul>
    </div>
    <div style="clear: both"></div>
    <div class="content2_smalltext">
      <ul>
        <li v-for="(articleItem, index) in otherArticle" :key="index">
          <div style="">
            <a
              class="f15"
              name="subject"
              :href="
                $ArticleUrl+'?chnid=' +
                articleItem.chnid +
                '&leafid=' +
                articleItem.leafid +
                '&docid=' +
                articleItem.code.substring(4, articleItem.code.length) +
                '&uid=' +
                item.uid +
                '&version=gov'
              "
              :title="articleItem.title"
              style="padding-top: 0px; padding-bottom: 0px; float: left"
              target="_blank"
              >{{ articleItem.title.slice(0, 18)
              }}<span v-if="articleItem.title.toString().length > 18"
                >...</span
              ></a
            ><span
              class="rgt"
              v-html="articleItem.deliveddate.slice(0, 10)"
            ></span>
            <div style="clear: both"></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListItem",
  data() {
    return {
      firstArticle: {},
      otherArticle: [],
      // 时间处理
    };
  },
  props: {
    item: Object,
  },
  mounted() {
    this.setItemData();
  },
  methods: {
    setItemData() {
      this.firstArticle = this.item.docList[0];
      this.otherArticle = this.item.docList.slice(1);
      // console.log(this.item.docList);
    },

    // 点击关键词搜索
    clickKeyword(event, id) {
      window.open(
        "http://s1.drcnet.com.cn/search/SearchAdvanced.aspx?fields=1^1^1^" +
          escape(event.target.innerHTML) +
          "&rootlm=" +
          id +
          "|" +
          id
      );
      // 弹出一个新页面
    },
  },
};
</script>

<style lang="less" scoped>
.content2_box {
  margin-top: 20px;
  .content2_title {
    background: url(./images/icon_shu.png) no-repeat center left;
    border-bottom: 2px solid #e5e5e5;
    padding: 8px 0;
    .f21 {
      color: #b71515;
      font-size: 20px;
      font-family: "微软雅黑";
      margin-left: 12px;
      font-weight: bold;
    }
    .f22 {
      color: #015293;
      font-size: 14px;
      font-family: "微软雅黑";
      margin-left: 36px;
      cursor: pointer;
    }
    .f23 {
      color: #333333;
      font-size: 12px;
      font-family: "微软雅黑";
      position: absolute;
      top: 14px;
      right: 0;
    }
    .f8 {
      margin: 0;
    }
  }
  .content2_pic {
    float: left;
    .content2_smalltitle {
      width: 160px;
      h4 {
        padding-top: 4px;
        font-family: "微软雅黑";
        font-size: 17px;
        color: #030303;
        padding-bottom: 4px;
        line-height: 22px;
      }

      .f6 {
        padding-top: 12px;
        /* line-height: 14px; */
      }
      .f7 {
        font-family: monospace;
        font-size: 12px;
        color: #333;
        line-height: 18px;
      }
    }
  }
  .content2_smalltext {
    li {
      padding: 6px 0;
      line-height: 18px;
      .f15 {
        color: #333333;
        font-family: "微软雅黑";
        font-size: 14px;
        /* float: left; */
        display: inline;
      }
      .rgt {
        font-family: "微软雅黑";
        float: right;
        display: inline;
        font-size: 13px;
        color: #333333;
      }
    }
  }
}
.overflow-rule {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
@media screen and (max-width: 769px) {
  .content2_box {
    padding: 0 16px;
    .content2_pic {
      width: 100% !important;
      .content2_smalltitle {
        width: calc(100% - 167px) !important;
      }
    }
    .content2_smalltext {
      ul {
        li {
          div {
            a {
              display: inline-block !important;
              width: calc(100% - 73px) !important;
              overflow: hidden !important;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}
</style>